import { createGlobalRoute } from '@townsquare/router/create-route';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { platformStarredFeedResource } from '@townsquare/starred-feed/resource';
import { starredFeedResource } from '@townsquare/starred-feed/starred-feed-resource';

export const starredRouteDefinition: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'starred',
	path: '/starred',
	layout: 'home',
	resources: [starredFeedResource, platformStarredFeedResource],
});
